import { makeAutoObservable, runInAction } from 'mobx';
import { showToast } from '../../../utils/toast';
import { IPB_INITIAL } from '../constants/onboard.constant';
import { benchmarkURL } from '../api/url';
import { handleFetch } from '../../../utils/handleFetch';

class BenchmarkStore {
	IPBData = [];
	IPBDataForm = IPB_INITIAL;
	isIPBChanged = false;
	errors = {};
	isDeleteConfirmModalOpen = false;
	selectedDeleteCompanyId = null;
	selectedCompanyName = null;

	constructor() {
		makeAutoObservable(this);
	}

	setErrors = (v) => (this.errors = v);

	openBenchmarksDeleteConfirmModal = (company) => {
		const { _id, companyName } = company;
		this.selectedDeleteCompanyId = _id;
		this.selectedCompanyName = companyName;
		this.isDeleteConfirmModalOpen = true;
	};

	closeDeleteConfirmModal = () => {
		this.isDeleteConfirmModalOpen = false;
	};

	getIPB = async () => {
		return await handleFetch({
			url: benchmarkURL(),
			method: 'GET',
			onSuccess: (data) => runInAction(() => (this.IPBData = data)),
		});
	};

	saveIPBData = async () => {
		const { _id, ...body } = this.IPBDataForm;
		const url = _id ? benchmarkURL(_id) : benchmarkURL();
		const isUpdate = !!_id;

		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url,
					method: isUpdate ? 'PUT' : 'POST',
					body,
					onSuccess: (data) => {
						runInAction(() => {
							const index = this.IPBData.findIndex((d) => d._id === data._id);
							if (index > -1) {
								this.IPBData[index] = data;
							} else {
								this.IPBData.push(data);
							}
							this.errors = {};
							this.isIPBChanged = false;
						});
					},
					onValidationError: (errors) => runInAction(() => (this.errors = errors)),
				});
				if (!success) throw new Error('Failed to save IPB data');
				return success;
			})(),
			{
				loading: isUpdate ? 'Updating IPB data...' : 'Creating IPB data...',
				success: isUpdate ? 'IPB data updated successfully!' : 'IPB data created successfully!',
				error: 'Failed to save IPB data',
			},
		);
	};

	handleSelectIPB = (id) => {
		const ipb = this.IPBData.find((d) => d._id === id) || IPB_INITIAL;
		this.IPBDataForm = { ...ipb };
	};

	deleteIPBData = async (id) => {
		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: benchmarkURL(id),
					method: 'DELETE',
					onSuccess: (data) => {
						runInAction(() => {
							const index = this.IPBData.findIndex((d) => d._id === data._id);
							if (index > -1) {
								this.IPBData.splice(index, 1);
							}
							this.isDeleteConfirmModalOpen = false;
						});
					},
				});
				if (!success) throw new Error('Failed to delete IPB data');
				return success;
			})(),
			{
				loading: 'Deleting IPB data...',
				success: 'IPB data deleted successfully!',
				error: 'Failed to delete IPB data',
			},
		);
	};

	handleChangeIPB = (e) => {
		const { id, value } = e.target;
		this.IPBDataForm[id] = value;
		this.isIPBChanged = true;
	};
}

export const benchmarkStore = new BenchmarkStore();
